var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2001.02 365.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2001.02,
    y1: 325.57,
    x2: 0,
    y2: 325.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#543a89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#66438d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#975a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c672a7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2001.02,0v337.52h-.51v-.04s-345.03-61.05-995.76,0c-.02,0-.42.04-.43.04-246.72,22.82-433.02,15.9-570.59,11.41-104.4-3.4-252.09-7.73-433.73-11.41V0h2001.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m2001.02,312.66v25.86h-.51v-.04s-345.03-61.05-995.76,0c-.14.01-.29.03-.43.04-636.39,59.66-989.34,2.54-1004.32.05v-25.91s119.1,20.51,345.96,25.86c65.44,1.55,139.84,1.84,222.94,0,125.83-2.78,271.6-10.4,436.35-25.86,650.73-61.05,995.77,0,995.77,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveBg);
export default __webpack_public_path__ + "static/media/wave-bg.fe6e9b9dbf275469bcb34ddd8082d028.svg";
export { ForwardRef as ReactComponent };